import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from "posthog-js/react";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./AuthContext";
import { ConfirmProvider } from "./components/ConfirmDialog";

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
const posthogOptions = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
  defaults: "2025-05-24",
  capture_exceptions: true,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
    <BrowserRouter>
      <AuthProvider>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </AuthProvider>
    </BrowserRouter>
  </PostHogProvider>
);
